/**
 * Shared empty-state component (§7g).
 *
 * Used for:
 *   - Project list (no projects yet)
 *   - Conversations tab (no conversations yet)
 *   - Documents tab (no documents yet)
 *   - Roundtable follow-up (panel picker hint) — 7h
 *
 * The `action` prop takes an element (usually a button) so callers
 * can drop in their own create-X CTA without the component having
 * to know about routing or state.
 */
export default function EmptyState({ icon, title, description, action }) {
  return (
    <div className="empty-state">
      <div className="empty-state-inner">
        {icon && <div className="empty-state-icon">{icon}</div>}
        <h3>{title}</h3>
        {description && <p>{description}</p>}
        {action && <div className="empty-state-action">{action}</div>}
      </div>
    </div>
  );
}
